import PopupCore from './popup-core';
import {dataset} from '../helpers';

export default class EmailPopUp extends PopupCore {
    getActionText() {
        return dataset(this.element, 'actionText', `Email ${this.element.innerText}`);
    }

    getActionIcon() {
        return '<svg style="width: 15px; height: 15px;" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>';
    }
}
